import { createNewSubAccountAlert } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const CreateNewSubAccountAlert = async (coin, subAccountName, hashrateThreshold, activeWorkersThreshold, emailList, accessToken)  => {
  try {
    const response = await createNewSubAccountAlert(coin, subAccountName, hashrateThreshold, activeWorkersThreshold, emailList, accessToken);    
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: extractApiErrorMessage(error) };
  }
};

export default CreateNewSubAccountAlert;
